<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M0 8L8 0V8H0Z" fill="black" fill-opacity="0.8" />
  </svg>
</template>
